import type * as React from 'react';
import { post } from '@Domain/Api';
import secondFactorEnrolled, {
	type SecondFactorEnrolledAction,
	type SecondFactorEnrolledPayload,
} from '@Application/Security/Authentications/Actions/secondFactorEnrolled';
import secondFactorEnrollmentFailed, {
	type SecondFactorEnrollmentFailedAction,
} from '@Application/Security/Authentications/Actions/secondFactorEnrollmentFailed';
import type ConfirmSecondFactorEnrollment from '@Application/Security/Authentications/Commands/ConfirmSecondFactorEnrollment';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = SecondFactorEnrolledAction | SecondFactorEnrollmentFailedAction;

export default (command: ConfirmSecondFactorEnrollment) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<SecondFactorEnrolledPayload>(
				`${parameters.api.host}/api/mfa/enrollment/confirmation`,
				command.toJSON(),
				{ retryOnUnauthorized: false },
			);

			const action = secondFactorEnrolled(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = secondFactorEnrollmentFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
